import axiosInstance from '../../Config/axiosConfig';

// Fetch current subscription for the authenticated user
// GET /user/subscription  →  { subscription: { status: 'active' | 'canceled' | ... , ... } }
export const getUserSubscriptionLogs = async () => {
  try {
    const response = await axiosInstance.get('/user/subscription');
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Determine if the user is subscribed based on /user/subscription response
export const getIsUserSubscribedFromLogs = (subscriptionResponse) => {
  const sub = subscriptionResponse?.subscription;
  if (!sub) return false;

  const status = String(sub.status || '').toLowerCase().trim();
  return status === 'active';
};

